import React from 'react';

export const progressData = [
  {
    id: 1,
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none">
        <path
          d="M0.833328 0.833496H4.16666L6.39999 11.9918C6.4762 12.3755 6.68492 12.7201 6.98962 12.9654C7.29431 13.2107 7.67558 13.341 8.06666 13.3335H16.1667C16.5577 13.341 16.939 13.2107 17.2437 12.9654C17.5484 12.7201 17.7571 12.3755 17.8333 11.9918L19.1667 5.00016H4.99999M8.33333 17.5002C8.33333 17.9604 7.96023 18.3335 7.5 18.3335C7.03976 18.3335 6.66666 17.9604 6.66666 17.5002C6.66666 17.0399 7.03976 16.6668 7.5 16.6668C7.96023 16.6668 8.33333 17.0399 8.33333 17.5002ZM17.5 17.5002C17.5 17.9604 17.1269 18.3335 16.6667 18.3335C16.2064 18.3335 15.8333 17.9604 15.8333 17.5002C15.8333 17.0399 16.2064 16.6668 16.6667 16.6668C17.1269 16.6668 17.5 17.0399 17.5 17.5002Z"
          stroke="#2F2F2F"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    ),
    progressName: 'Shopping Cart',
    link: '/shopping-cart',
  },
  {
    id: 2,
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="18"
        viewBox="0 0 20 18"
        fill="none">
        <path
          d="M13.3333 16.5V14.8333C13.3333 13.9493 12.9822 13.1014 12.357 12.4763C11.7319 11.8512 10.8841 11.5 10 11.5H4.16668C3.28262 11.5 2.43478 11.8512 1.80965 12.4763C1.18453 13.1014 0.833344 13.9493 0.833344 14.8333V16.5M16.6667 5.66667V10.6667M19.1667 8.16667H14.1667M10.4167 4.83333C10.4167 6.67428 8.92429 8.16667 7.08334 8.16667C5.24239 8.16667 3.75001 6.67428 3.75001 4.83333C3.75001 2.99238 5.24239 1.5 7.08334 1.5C8.92429 1.5 10.4167 2.99238 10.4167 4.83333Z"
          stroke="#2F2F2F"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    ),
    progressName: 'Attendees',
    link: '/shopping-cart/attendees',
  },
  {
    id: 3,
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none">
        <path
          d="M6.66667 5H17.5M6.66667 10H17.5M6.66667 15H17.5M2.5 5H2.50833M2.5 10H2.50833M2.5 15H2.50833"
          stroke="#2F2F2F"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    ),
    progressName: 'Review',
    link: '/shopping-cart/attendees/review-order',
  },
  {
    id: 4,
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="16"
        viewBox="0 0 20 16"
        fill="none">
        <path
          d="M0.833313 6.3335H19.1666M2.49998 1.3335H17.5C18.4205 1.3335 19.1666 2.07969 19.1666 3.00016V13.0002C19.1666 13.9206 18.4205 14.6668 17.5 14.6668H2.49998C1.5795 14.6668 0.833313 13.9206 0.833313 13.0002V3.00016C0.833313 2.07969 1.5795 1.3335 2.49998 1.3335Z"
          stroke="#2F2F2F"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    ),
    progressName: 'Payment',
    link: '/shopping-cart/attendees/review-order/payment',
  },
  {
    id: 5,
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none">
        <path
          d="M18.3333 9.23355V10.0002C18.3323 11.7972 17.7504 13.5458 16.6744 14.9851C15.5984 16.4244 14.086 17.4773 12.3628 17.9868C10.6395 18.4963 8.79768 18.4351 7.11202 17.8124C5.42636 17.1896 3.98717 16.0386 3.00909 14.5311C2.03101 13.0236 1.56645 11.2403 1.68469 9.44714C1.80293 7.65402 2.49763 5.94715 3.66519 4.58111C4.83275 3.21506 6.41061 2.26303 8.16345 1.867C9.91629 1.47097 11.7502 1.65216 13.3916 2.38355M18.3333 3.33355L9.99996 11.6752L7.49996 9.17521"
          stroke="#2F2F2F"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    ),
    progressName: 'Confirmation',
    link: '/shopping-cart/attendees/review-order/payment/order-confirmation',
  },
];
